function getUserRole() {
  try {
    const root = JSON.parse(localStorage.getItem("persist:root"));
    if (!root || !root.auth) return null;

    const auth = JSON.parse(root.auth);
    return auth.role || null;
  } catch (error) {
    console.error("Error reading user role:", error);
    return null;
  }
}

const logoutFunction = () => {
  localStorage.clear();
  window.location.href = '/';
};

const setCourseStorage = (id) =>{
  localStorage.setItem("course_creation_id", id);
}

const getCourseStorage = () =>{
  let id = localStorage.getItem("course_creation_id");
  return id
}

const deleteCourseStorage = () =>{
  localStorage.removeItem("course_creation_id");
}

const deleteUploadedVideosStorage = () =>{
  localStorage.removeItem("uploadedVideos");
}

export default {
  getUserRole,
  logoutFunction,
  setCourseStorage,
  getCourseStorage,
  deleteCourseStorage,
  deleteUploadedVideosStorage
};
